const posts = document.querySelectorAll('.blogPostCard');
posts.forEach((post) => {
  const label = post.querySelector('.blogCardHover');
  post.addEventListener('mousemove', function (event) {
    let x = event.clientX + 15; // Position to the right of the cursor with some spacing
    if (x + label.offsetWidth > windowWidth) {
      x = x - label.offsetWidth - 30;
    }
    const y = event.clientY + 10 - label.offsetHeight / 2; // Center vertically
    label.style.left = `${x}px`;
    label.style.top = `${y}px`;
  });
});
